export default __webpack_public_path__ + "static/ku_czarna-4eda4b3d2ab9bed29b042a5c08426e98.jpg";